/** Home: /dashboard... — Phân hệ: /com/dashboard, /fob/dashboards, ... */
export function isDashboardRoute(pathname = '') {
    const path = pathname.replace(/\/+$/, '') || '/';
    // Khớp cả singular và plural: /dashboard/module-list, /com/dashboard, /fob/dashboards
    return /(^|\/)dashboards?(\/|$)/.test(path);
}
